import { render, staticRenderFns } from "./DiseaseDetail.vue?vue&type=template&id=1e9ab974&scoped=true"
import script from "./DiseaseDetail.vue?vue&type=script&lang=js"
export * from "./DiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetail.vue?vue&type=style&index=0&id=1e9ab974&prod&scoped=true&lang=css"
import style1 from "./DiseaseDetail.vue?vue&type=style&index=1&id=1e9ab974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9ab974",
  null
  
)

export default component.exports